import { ConfigProvider } from "antd";
import React from "react";
import zhCN from "antd/es/locale/zh_CN";
import { StyleProvider } from '@ant-design/cssinjs';

export function rootElement(element) {
    return <StyleProvider layer hashPriority="low" ><ConfigProvider locale={zhCN}>{element}</ConfigProvider></StyleProvider>
}